// extracted by mini-css-extract-plugin
export default {"skillsGrid":"Skills_skillsGrid__k6Umz","skillCard":"Skills_skillCard__O0aLV"};